import { FunctionComponent } from 'react';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import PublicInteractiveBodyWomenComponent from 'components/modules/public/interactiveBody/woman';

import StyledComponent from './styles';
import { Props } from './types';

const PublicSectionSilhouetteVariantWoman: FunctionComponent<Props> = ({ translations, products, buttonProps }) => {
    const { headline } = translations;

    return (
        <StyledComponent className="public-section-silhouette-variant-woman">
            <LayoutContainer size={Sizes.Medium}>
                {headline && (
                    <div
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                )}
                <PublicInteractiveBodyWomenComponent
                    buttonProps={buttonProps}
                    products={products}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionSilhouetteVariantWoman;
